(function () {
  var MIN_QTY = 1;
  var MAX_QTY = 99;

  function clampQty(value) {
    var qty = parseInt(String(value), 10);
    if (isNaN(qty) || qty < MIN_QTY) return MIN_QTY;
    if (qty > MAX_QTY) return MAX_QTY;
    return qty;
  }

  function parseTierOrder(v) {
    var t = ((v && (v.title || v.option1)) || '') + '';
    var m = t.match(/tier\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : 999;
  }

  function sortLaVariants(variants) {
    return (variants || []).slice().sort(function (a, b) {
      return parseTierOrder(a) - parseTierOrder(b);
    });
  }

  function resolveActiveLaVariant(variants) {
    return sortLaVariants(variants).find(function (v) {
      return v.available;
    }) || null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.currency && window.Shopify.currency.active) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    var amount = (Number(cents) || 0) / 100;
    return '$' + amount.toFixed(2);
  }

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderTierTable(root, product) {
    var tbody = root.querySelector('[data-sacbe-la-tier-tbody]');
    var cta = root.querySelector('[data-sacbe-la-atc]');
    var tierLabel = root.querySelector('[data-sacbe-la-active-tier]');
    if (!tbody) return;

    var variants = (product && product.variants) || [];
    var sorted = sortLaVariants(variants);
    var active = resolveActiveLaVariant(variants);
    var activeIdx = active ? sorted.findIndex(function (v) { return v.id === active.id; }) : -1;

    tbody.innerHTML = '';
    sorted.forEach(function (v, i) {
      var tr = document.createElement('tr');
      var isSellingNow = activeIdx >= 0 && i === activeIdx && !!v.available;
      tr.className =
        'sacbe-la-landing__tier-row' +
        (isSellingNow ? ' sacbe-la-landing__tier-row--active' : ' sacbe-la-landing__tier-row--muted');

      var status;
      var statusClass = 'sacbe-la-landing__tier-status';
      if (!v.available) {
        status = 'Sold out';
      } else if (isSellingNow) {
        status = 'Selling now';
        statusClass += ' sacbe-la-landing__tier-status--now';
      } else {
        status = 'Upcoming';
      }

      tr.innerHTML =
        '<td>' +
        escapeHtml(v.title || 'Tier ' + (i + 1)) +
        '</td><td>' +
        escapeHtml(formatMoney(v.price)) +
        '</td><td><span class="' +
        statusClass +
        '">' +
        status +
        '</span></td>';
      tbody.appendChild(tr);
    });

    if (tierLabel) {
      tierLabel.textContent = active
        ? (active.title || 'Active tier') + ' — ' + formatMoney(active.price)
        : 'Sold out';
    }

    if (cta) {
      if (active && active.id) {
        cta.disabled = false;
        cta.setAttribute('data-variant-id', String(active.id));
      } else {
        cta.disabled = true;
        cta.removeAttribute('data-variant-id');
      }
    }
  }

  function readQty(root) {
    var input = root.querySelector('[data-sacbe-la-qty-input]');
    if (!input) return MIN_QTY;
    var qty = clampQty(input.value);
    input.value = String(qty);
    return qty;
  }

  function addToCart(root, btn) {
    var variantId = parseInt(String(btn.getAttribute('data-variant-id') || ''), 10);
    if (!variantId || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var quantity = readQty(root);
    var original = (btn.textContent || '').trim();
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || (payload && payload.status >= 400)) {
            throw new Error(
              (payload && (payload.description || payload.message)) || 'Could not add to cart'
            );
          }
          return payload;
        });
      })
      .then(function () {
        window.location.assign(getCartUrl());
      })
      .catch(function (err) {
        window.alert(err && err.message ? err.message : 'Unable to add tickets right now.');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = !variantId;
        if ((btn.textContent || '').trim() === 'Adding…') btn.textContent = original;
      });
  }

  function initRoot(root) {
    var handle = root.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        renderTierTable(root, product);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var stepBtn = event.target.closest('[data-sacbe-la-qty-step]');
    if (stepBtn) {
      var root = stepBtn.closest('.sacbe-la-landing');
      var qtyRoot = stepBtn.closest('[data-sacbe-la-qty]');
      if (!root || !qtyRoot) return;
      var input = qtyRoot.querySelector('[data-sacbe-la-qty-input]');
      if (!input) return;
      event.preventDefault();
      var step = Number(stepBtn.getAttribute('data-sacbe-la-qty-step') || 0);
      input.value = String(clampQty(clampQty(input.value) + step));
      return;
    }

    var atcBtn = event.target.closest('[data-sacbe-la-atc]');
    if (!atcBtn) return;
    var landing = atcBtn.closest('.sacbe-la-landing');
    if (!landing) return;
    event.preventDefault();
    addToCart(landing, atcBtn);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-sacbe-la-qty-input]');
    if (!input || !input.closest('.sacbe-la-landing')) return;
    input.value = String(clampQty(input.value));
  });

  function boot() {
    document.querySelectorAll('.sacbe-la-landing[data-product-handle]').forEach(initRoot);

    document.querySelectorAll('.sacbe-la-landing__video-el').forEach(function (video) {
      if (video.tagName !== 'VIDEO') return;
      video.muted = true;
      video.playsInline = true;
      function tryPlay() {
        video.play().catch(function () {});
      }
      video.addEventListener('loadedmetadata', tryPlay);
      video.addEventListener('canplay', tryPlay);
      if (video.readyState >= 2) tryPlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
